import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0ad7319d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate top-bar" }
const _hoisted_2 = {
  key: 0,
  class: "logo"
}
const _hoisted_3 = ["src", "width"]
const _hoisted_4 = { class: "title_platform" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { style: {"display":"flex","justify-self":"right","overflow":"visible"} }
const _hoisted_8 = { class: "notification" }
const _hoisted_9 = {
  key: 0,
  class: "alert-notification"
}

import UserInfoWidget from '@/components/widgets/UserInfoWidget.vue'
import useWindowWidth from '@/composables/useWindowWidth'
import { useMenu } from '@/store/useMenu'
import { ref, onMounted} from 'vue'
import { useAuth } from '@/store/useAuth'
import NotificationService from '@/services/NotificationService'
import main from '@/data/main.js'



export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const auth = useAuth()
const { windowWidth } = useWindowWidth()
const store = useMenu()
const pendingNotifications = ref(0)
const notificationService = new NotificationService()


//const search = ref('')

onMounted(async () => {
    if(!auth.token)
    {
        return;
    }
  pendingNotifications.value = await notificationService.CountUnreadNotification(auth.token)  
})

const handleMenu = () => {
    store.toggleMenu()
    window.scrollTo(0, 0);
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(windowWidth) > 950)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: {name:'home'},
            style: {"cursor":"pointer"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(main).LOGO_SMALL,
                width: _unref(main).LOGO_WIDTH
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(main).NAME_PLATFORM), 1)
        ]))
      : (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: {name:'home'},
          style: {"cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(main).LOGO_SMALL,
              class: "logo",
              style: {"width":"80px"}
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_RouterLink, { to: {name: 'notifications'} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (pendingNotifications.value > 0 && _ctx.$route.name != 'notifications')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(pendingNotifications.value), 1))
                : _createCommentVNode("", true),
              (_unref(auth).token)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    name: "bi-bell-fill",
                    scale: "1.2",
                    style: {"margin-right":"5px"}
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      (_unref(windowWidth) >= 950)
        ? (_openBlock(), _createBlock(UserInfoWidget, {
            key: 0,
            class: "widget"
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(windowWidth) <= 950)
      ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 2,
          name: "hi-menu-alt-3",
          scale: "2",
          class: "menu-btn",
          onClick: handleMenu
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})